import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top on every navigation — including clicking the
 * same route again (e.g. tapping "Start" while already on "/"). React Router
 * issues a fresh `location.key` for every navigation, even when the pathname
 * is unchanged, so keying the effect on `key` covers both real route changes
 * and same-route re-clicks.
 *
 * If the URL contains a hash (e.g. /#kontakt), we skip the reset so anchor
 * links keep working.
 *
 * Place inside <BrowserRouter> but outside <Routes>.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, key]);

  return null;
}
